(function ($) {
    $(".sector").on("mouseover", function (){
        const target = $(this).attr("id");
        console.log(target);
        $(".section-vital-conditions .item").each(function () {
            $(this).css("opacity", ".5");
        })
        $('[data-id=' + target + ']').css("opacity", "1");
    })

    $(".sector").on("mouseleave", function (){
        $(".section-vital-conditions .item").each(function () {
            $(this).css("opacity", "1");
        })
    })
})(jQuery);